import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiDragMoveLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import Select from '@/components/ui/kit/Select';
import useGimbalCommand from '@/hooks/command/dji/useGimbalCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const GIMBAL_MODES = [
  { value: 0, label: 'Reset' },
  { value: 1, label: 'Downward' },
  // NOTE: The following modes are not tested yet
  // { value: 2, label: 'Gimbal Pan Recenter' },
  // { value: 3, label: 'Gimbal Pitch Downward' },
];

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [mode, setMode] = useState(GIMBAL_MODES[0].value);
  const [isProcessing, setProcessing] = useState(false);
  const gimbalCommand = useGimbalCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeDJICommand(robot, gimbalCommand.reset(mode));

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    notifier.success(`Gimbal reset successfully on ${robot.name}.`);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    notifier.error(`Failed to reset gimbal on ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    process(robots[0]);
  }, [isProcessing]);

  const handleChange = (e) => {
    setMode(e.target.value);
  };

  const doCommand = () => {
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Reset the gimbal to the specified position</div>
      <div className={cx('form')}>
        <Select id="action" value={mode} onChange={handleChange}>
          {GIMBAL_MODES.map((mode) => (
            <option key={mode.value} value={mode.value}>
              {mode.label}
            </option>
          ))}
        </Select>
      </div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Gimbal';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiDragMoveLine;
Command.Panel = Panel;

export default Command;
